export function appendPx(spacing: number | string) {
  if (typeof spacing === 'string') {
    return spacing;
  }
  return `${spacing}px`;
}

export function handleCopyToClipboard(str: string) {
  if (typeof window == 'undefined' || typeof document === 'undefined') {
    return null;
  }
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  return alert(`Copied ${str} to clipboard!`);
}

export function hexToRGB(hex: string, alpha: number | string) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r},${g},${b},${alpha})`;
  }
  return `rgb(${r},${g},${b})`;
}
